module.exports = __webpack_public_path__ + "img/calendar.12aaa94b.svg";